var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M16.627 29.024H1.525C.682 29.024 0 28.342 0 27.499v-9.858l9.076-7.516 9.075 7.516v9.858c0 .843-.683 1.525-1.524 1.525",
    transform: "translate(.075 .08)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M3.646 0C1.633 0 0 1.633 0 3.646s1.633 3.646 3.646 3.646 3.646-1.633 3.646-3.646S5.659 0 3.646 0",
    transform: "translate(.075 .08)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M13.748 7.653l-2.432 2.014 8.617 7.135v9.75h1.366c.842 0 1.525-.683 1.525-1.526v-9.858l-9.076-7.515z",
    transform: "translate(.075 .08)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.5dc6048e32caa5ac995fea5b8d199585.svg";
export { ForwardRef as ReactComponent };